export function prependUrlWithHttps(url: string): string {
  const httpPrefix = /^((http|https):\/\/)/;
  return httpPrefix.test(url) ? url : `https://${url}`;
}
